import { Action } from '@ngrx/store';
import { ErrorResponse } from '~shared/modules/error-handler';
import { Hub } from '~app/modules/custom-hub/models';

export enum HubActionTypes {
    LOAD_HUB_CONFIG_CONTENT = '[CustomHub] Hub Load',
    LOAD_HUB_CONFIG_CONTENT_SUCCESS = '[CustomHub] Hub Load Success',
    LOAD_HUB_CONFIG_CONTENT_FAILURE = '[CustomHub] Hub Load Failure'
}

export class LoadCustomHubConfigContent implements Action {
    readonly type = HubActionTypes.LOAD_HUB_CONFIG_CONTENT;

    constructor(public payload: { pageName: string }) {
    }
}

export class LoadCustomHubConfigContentSuccess implements Action {
    readonly type = HubActionTypes.LOAD_HUB_CONFIG_CONTENT_SUCCESS;

    constructor(public payload: { hub: Hub }) {
    }
}

export class LoadCustomHubConfigContentFailure implements Action {
    readonly type = HubActionTypes.LOAD_HUB_CONFIG_CONTENT_FAILURE;

    constructor(public payload: { error: ErrorResponse }) {
    }
}

export type CustomHubActionsUnion = LoadCustomHubConfigContent
| LoadCustomHubConfigContentSuccess
| LoadCustomHubConfigContentFailure;
